<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 760px; height: 600px" data-cy="case-view-work-item-events">
  <div class="section" style="
      display: flex;
      flex-direction: column;
      height: 100%;
      max-height: 100%;
    " data-cy="case-view-work-item-events-section">
    <!-- Header -->
    <div class="section-header" style="flex-basis: 30px; display: flex; align-items: center" data-cy="case-view-work-item-events-header">
      <!-- Conditional text based on view type -->
      <div class="section-header-title" style="flex: 1" data-cy="case-view-work-item-events-title">
        {{ getHeaderText() }}
      </div>
      <!-- Button to toggle views -->
      <button (click)="toggleDetailedView()" class="tdo-button tdo-view-more" style="margin-left: auto; color: white" data-cy="case-view-work-item-events-toggle-btn">
        <mat-icon>more_horiz</mat-icon>
      </button>
    </div>

    <!-- Main content -->
    <div class="section-content" style="flex: 1; overflow-y: auto" data-cy="case-view-work-item-events-content">
      <!-- Basic view -->
      <div *ngIf="!showDetailedView" data-cy="case-view-work-item-events-basic-view">
        <tdo-table *ngIf="events.length > 0" [dataSource]="events" [isSearchable]="false" data-cy="case-view-work-item-events-basic-table">
          <!-- Event type column -->
          <tdo-table-column displayName="Type" propertyName="enumWorkItemEventTypeID" [rowTemplate]="eventType" data-cy="case-view-work-item-events-basic-type-column">
            <ng-template #eventType let-row>
              <div data-cy="case-view-work-item-events-basic-type-value">{{ getEventType(row.enumWorkItemEventTypeID) }}</div>
            </ng-template>
          </tdo-table-column>

          <!-- Start time column -->
          <tdo-table-column displayName="Start Time" propertyName="EventDateStart" [rowTemplate]="start" data-cy="case-view-work-item-events-basic-start-column">
            <ng-template #start let-row>
              <div data-cy="case-view-work-item-events-basic-start-value">{{ getDate(row.EventDateStart) }}</div>
            </ng-template>
          </tdo-table-column>

          <!-- End time column -->
          <tdo-table-column displayName="End Time" propertyName="EventDateFinish" [rowTemplate]="finish" data-cy="case-view-work-item-events-basic-end-column">
            <ng-template #finish let-row>
              <ng-container *ngIf="row.EventDateFinish">
                <div data-cy="case-view-work-item-events-basic-end-value">{{ getDate(row.EventDateFinish) }}</div>
              </ng-container>
            </ng-template>
          </tdo-table-column>

          <!-- Provider column -->
          <tdo-table-column displayName="Provider" propertyName="ProviderDoctorId" [rowTemplate]="provider" data-cy="case-view-work-item-events-basic-provider-column">
            <ng-template #provider let-row>
              <div data-cy="case-view-work-item-events-basic-provider-value">{{ getDoctorName(row.ProviderDoctorId) }}</div>
            </ng-template>
          </tdo-table-column>
        </tdo-table>

        <!-- Message if no events are available -->
        <div *ngIf="events.length === 0" data-cy="case-view-work-item-events-basic-empty">
          No events available for this case.
        </div>
      </div>

      <!-- Detailed view -->
      <div *ngIf="showDetailedView" data-cy="case-view-work-item-events-detailed-view">
        <tdo-table *ngIf="events.length > 0" [dataSource]="events" [isSearchable]="false" class="styled-table" data-cy="case-view-work-item-events-detailed-table">
          <!-- Event type column in detailed view -->
          <tdo-table-column displayName="Type" propertyName="eventType" [rowTemplate]="eventType" data-cy="case-view-work-item-events-detailed-type-column">
            <ng-template #eventType let-row>
              <div data-cy="case-view-work-item-events-detailed-type-value">{{ row.eventType }}</div>
            </ng-template>
          </tdo-table-column>

          <!-- Procedure column -->
          <tdo-table-column displayName="Procedure" propertyName="ProcedureName" [rowTemplate]="procedure" data-cy="case-view-work-item-events-detailed-procedure-column">
            <ng-template #procedure let-row>
              <div data-cy="case-view-work-item-events-detailed-procedure-value">{{ row.ProcedureName }}</div>
            </ng-template>
          </tdo-table-column>

          <!-- Start time column -->
          <tdo-table-column displayName="Start Time" propertyName="EventDateStart" [rowTemplate]="start" data-cy="case-view-work-item-events-detailed-start-column">
            <ng-template #start let-row>
              <ng-container *ngIf="row.EventDateStart && row.recType != 1">
                <div data-cy="case-view-work-item-events-detailed-start-value">{{ getDate(row.EventDateStart) }}</div>
              </ng-container>
            </ng-template>
          </tdo-table-column>

          <!-- End time column -->
          <tdo-table-column displayName="End Time" propertyName="EventDateFinish" [rowTemplate]="finish" data-cy="case-view-work-item-events-detailed-end-column">
            <ng-template #finish let-row>
              <ng-container *ngIf="row.EventDateFinish && row.recType != 1">
                <div data-cy="case-view-work-item-events-detailed-end-value">{{ getDate(row.EventDateFinish) }}</div>
              </ng-container>
            </ng-template>
          </tdo-table-column>

          <!-- Duration in formatted string -->
          <tdo-table-column displayName="Duration" propertyName="durationFormatted" [rowTemplate]="durationFormatted" data-cy="case-view-work-item-events-detailed-duration-column">
            <ng-template #durationFormatted let-row>
              <div data-cy="case-view-work-item-events-detailed-duration-value">{{ row.durationFormatted }}</div>
            </ng-template>
          </tdo-table-column>

         
          
          <!-- Provider column -->
          <tdo-table-column displayName="Provider" propertyName="DoctorName" [rowTemplate]="provider" data-cy="case-view-work-item-events-detailed-provider-column">
            <ng-template #provider let-row>
              <div data-cy="case-view-work-item-events-detailed-provider-value">{{ row.DoctorName }}</div>
            </ng-template>
          </tdo-table-column>
        </tdo-table>

        <!-- Message if no events are available -->
        <div *ngIf="events.length === 0" data-cy="case-view-work-item-events-detailed-empty">
          No events available for this case.
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px" data-cy="case-view-work-item-events-footer">
      <div style="flex: 1; margin-right: 6px"></div>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px" data-cy="case-view-work-item-events-ok-btn">
        Ok
      </button>
    </div>
  </div>
</div>